import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as globals from '../../../../components/GlobalScripts.js';

function money(n) {
    const x = Number(n || 0);
    return x.toFixed(2);
}
function dt(s) {
    if (!s) return '—';
    return String(s).slice(0, 19).replace('T', ' ');
}

export default function CuponRedencionesModal({ open, coupon, apiBase, apiPayloadBase, onClose }) {
    const [loading, setLoading] = useState(false);
    const [q, setQ] = useState('');
    const [page, setPage] = useState(1);
    const [paging, setPaging] = useState({ page: 1, total_pages: 1, total: 0, itemsPerPage: 12 });
    const [items, setItems] = useState([]);

    const close = () => onClose?.();

    const fetchRed = async ({ page: nextPage = 1 } = {}) => {
        if (!coupon?.id) return;

        setLoading(true);
        globals.openViewCharge();

        try {
            const res = await axios.post(`${apiBase}/admin/cupones/redenciones.php`, {
                ...apiPayloadBase,
                cupon_id: coupon.id,
                q,
                page: nextPage,
                itemsPerPage: paging.itemsPerPage,
            });

            if (res.data?.mensaje === 'success') {
                setItems(Array.isArray(res.data?.items) ? res.data.items : []);

                const p = res.data?.paging || null;
                if (p) {
                    setPaging({
                        page: Number(p.page || nextPage),
                        total_pages: Number(p.total_pages || 1),
                        total: Number(p.total || 0),
                        itemsPerPage: Number(p.itemsPerPage || paging.itemsPerPage),
                    });
                } else {
                    setPaging((prev) => ({ ...prev, page: nextPage }));
                }

                setPage(nextPage);
                return;
            }

            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: res.data?.mensaje || "No se pudieron cargar redenciones",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } catch {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar redenciones",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4200
            });
        } finally {
            globals.closeViewCharge();
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!open) return;
        setQ('');
        setPage(1);
        setItems([]);
        setPaging({ page: 1, total_pages: 1, total: 0, itemsPerPage: 12 });

        setTimeout(() => fetchRed({ page: 1 }), 0);
    }, [open, coupon?.id]);

    if (!open) return null;

    return (
        <div className="cupon-modal__overlay" onMouseDown={close}>
            <div className="cupon-modal cupon-modal--wide" onMouseDown={(e) => e.stopPropagation()}>
                <div className="cupon-modal__head">
                    <div className="cupon-modal__title">Redenciones · {coupon?.codigo}</div>

                    <button className="cupon-iconbtn" type="button" onClick={close} title="Cerrar">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>

                <div className="cupon-modal__body">
                    <div className="cupon-red__bar">
                        <div className="cupon-input-wrap">
                            <span className="cupon-input-ico" aria-hidden="true">
                                <svg viewBox="0 0 24 24">
                                    <path d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" fill="none" stroke="currentColor" strokeWidth="2.2" />
                                    <path d="M16.5 16.5 21 21" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
                                </svg>
                            </span>

                            <input
                                className="cupon-input"
                                placeholder="Buscar cliente..."
                                value={q}
                                onChange={(e) => setQ(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && fetchRed({ page: 1 })}
                            />
                        </div>

                        <button className="cupon-btn cupon-btn--primary" type="button" onClick={() => fetchRed({ page: 1 })} disabled={loading}>
                            Buscar
                        </button>
                    </div>

                    <div className="cupon-red__table">
                        <div className="cupon-table__head cupon-table__head--mini">
                            <div>Fecha</div>
                            <div>Cliente</div>
                            <div>Subtotal</div>
                            <div>Descuento</div>
                            <div>Total</div>
                            <div>Payment</div>
                            <div>Plan</div>
                        </div>

                        {loading && <div className="cupon-table__empty">Cargando...</div>}

                        {!loading && items.length === 0 && (
                            <div className="cupon-table__empty">Sin redenciones.</div>
                        )}

                        {!loading && items.map((r) => (
                            <div key={r.id} className="cupon-row cupon-row--mini">
                                <div>{dt(r.created_at)}</div>

                                <div>
                                    <div style={{ fontWeight: 800 }}>{r.cliente_nombre || '—'}</div>
                                    <div className="cupon-mono" style={{ fontSize: 12, opacity: 0.8 }}>{r.keylogin}</div>
                                </div>

                                <div>${money(r.subtotal)} {r.moneda || 'USD'}</div>
                                <div>- ${money(r.descuento)}</div>
                                <div><b>${money(r.total_final)}</b></div>
                                <div className="cupon-mono">{r.payment_id || '—'}</div>
                                <div>{r.membership_id || '—'}</div>
                            </div>
                        ))}
                    </div>

                    <div className="cupon-pager cupon-pager--inside">
                        <button
                            className="cupon-btn cupon-btn--ghost"
                            type="button"
                            onClick={() => fetchRed({ page: Math.max(1, page - 1) })}
                            disabled={page <= 1 || loading}
                        >
                            Anterior
                        </button>

                        <div className="cupon-pager__meta">
                            <b>Página:</b> {paging.page} / {paging.total_pages} &nbsp;·&nbsp; <b>Total:</b> {paging.total}
                        </div>

                        <button
                            className="cupon-btn cupon-btn--ghost"
                            type="button"
                            onClick={() => fetchRed({ page: Math.min(paging.total_pages || 1, page + 1) })}
                            disabled={page >= (paging.total_pages || 1) || loading}
                        >
                            Siguiente
                        </button>
                    </div>

                    <div className="cupon-modal__foot">
                        <button className="cupon-btn cupon-btn--ghost" type="button" onClick={close}>
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
